import { VHeaders } from '@/models/pagedlistmodel';

export function getVehicleReviveSettingHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'vehicleReviveSettings.reviveSettingsGridHeaders.settingType'
      ) as string,
      value: 'settingType',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'vehicleReviveSettings.reviveSettingsGridHeaders.fromReviveStepName'
      ) as string,
      value: 'fromReviveStepName',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'vehicleReviveSettings.reviveSettingsGridHeaders.toReviveStepName'
      ) as string,
      value: 'toReviveStepName',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t(
        'vehicleReviveSettings.reviveSettingsGridHeaders.action'
      ) as string,
      sortable: false,
    },
  ];
}
